import React, { useRef, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import closeIcon from "../../images/close-icon.png";
import DummyAgentImage from '../../images/DummyAgent.svg'
import LanguageToggle from "../../utils/LanguageToggle/LanguageToggle";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";

import "./ConversationStyleSheet.css";

function ConversationHeader(props) {
  const menuContainerRef = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isFullScreen = localStorage.getItem("openInFullScreen");

  let isActiveConversation = props.isActiveConversation();
  let canDownloadTranscript = s360ConfigService.config?.configDetails?.sendChatTranscript;
  let statusColor = props?.conversation?.agentInfo?.isActive ? "#e60000" : "#00cc00";
  let notificationEnabled = s360ConfigService?.config?.notification?.isEnabled
  let isManualSessionActionEnabled = s360ConfigService.config?.configDetails?.allowManualSessionEnd;

  let showMizimizeOnFullScreen = s360ConfigService?.config?.showMinimizeIconInFullScreen;
  const isAnyMenuActionsEnabled = canDownloadTranscript || isManualSessionActionEnabled || notificationEnabled;
  console.log(canDownloadTranscript,isAnyMenuActionsEnabled,"canDownloadTranscript")

  let hideHis = props.config.hideChatHis;
  let showLogo = isNullOrUndefined(props.config.showLogo) ? true : props.config.showLogo;

  const { isShowToggle } = props;
  const customDesign = props.config?.customDesign ?? {};

  const onClose = () => {
    if (typeof props.actions?.onHideChatWindow === 'function') {
      props.actions.onHideChatWindow();
    }
    props.actions.onStartUpClick();
  };

  const closeOnFullScreen = () => {
    window.parent.postMessage(
      {
        closeFunctionFullScreen: "true",
      },
      "*"
    );
  };

  const onSendChatTranscriptClick = () => {
    setIsMenuOpen(false)
    props.onSendChatTranscriptClick();
  }

  const closeConversationClick = () => {
    let tempIsFullScreen = localStorage.getItem("openInFullScreen");
    //todo : bob
    if (tempIsFullScreen) {
      closeOnFullScreen();
    } else {
      setIsMenuOpen(false)
      props.closeConversationClick();
    }
  };

  const parseName = () => {
    const  agentInfo  = sessionStorage.getItem("agentName");
    console.log(agentInfo,"agentInfo")
    return agentInfo ? agentInfo :s360ConfigService?.config?.configDetails?.brandName;
  };

  const menuOptionImage = (visible) => {
    return (
      <svg
        visibility={visible ? "visible" : "hidden"}
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 50 50"
        onClick={onMenuAction}
        className={`s360-conversation-menu-option-image-${props.config.theme}`}
        style={{
          ...props.config?.customDesign?.conversationHeaderMenuOptionImage,
          PaddingRight: '0rem',
          position: 'absolute',
          left: '81%',
          top: '2.5rem',
          width: '21px',
          fill: s360ConfigService?.config?.configDetails?.primaryFontColor
        }}
      >
        <path
          d="M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z"></path>
      </svg>
    );
  };

  const menuOptionClose = () => setIsMenuOpen(false);

  const onMenuAction = () => setIsMenuOpen(true);

  const onBackAction = () => props.actions.showLandingScreen();

  return (
    <div className="s360-conversation-header-container"  style={{ 
      ...customDesign?.conversationHeaderContainer, 
      display: s360ConfigService?.config?.preview ? 'none' : 'flex' 
    }}>
      <div style={{ width: "100%", marginLeft: 12, display: "flex", alignItems: "center" }}>
        {!hideHis && !s360ConfigService?.config?.sandBox && (
          <div className="s360-conversation-header-back-button-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 24 24"
              onClick={()=>onBackAction()}
              fill={s360ConfigService?.config?.configDetails?.primaryFontColor}
              style={customDesign?.conversationHeaderBackButton}
            >
              <path
                d="M 10 5.3417969 C 9.744125 5.3417969 9.4879688 5.4412187 9.2929688 5.6367188 L 3.6367188 11.292969 C 3.2457187 11.683969 3.2457187 12.317031 3.6367188 12.707031 L 9.2929688 18.363281 C 9.6839688 18.754281 10.317031 18.754281 10.707031 18.363281 L 10.792969 18.277344 C 11.183969 17.886344 11.183969 17.253281 10.792969 16.863281 L 6.9296875 13 L 20 13 C 20.552 13 21 12.552 21 12 C 21 11.448 20.552 11 20 11 L 6.9296875 11 L 10.792969 7.1367188 C 11.183969 6.7457187 11.183969 6.1126563 10.792969 5.7226562 L 10.707031 5.6367188 C 10.511531 5.4412187 10.255875 5.3417969 10 5.3417969 z"></path>
            </svg>
          </div>
        )}
        {showLogo && s360ConfigService?.config?.configDetails?.brandIcon !== "" && (
          <div className={`s360-conversation-header-details-image${isFullScreen ? "-fs" : ""}`}>
            <div id="headerImgDiv" style={{ fontSize: '15px', textAlign: 'center', width: '2em', height: '2em', display: ' inline-flex' }}>
              <img
                id="s360-agent-image"
                className="s360-conversation-header-logo-icon"
                style={customDesign?.conversationHeaderLogoIcon}
                src={props.config.configDetails?.brandIcon || DummyAgentImage}
                alt=""
              ></img>
            </div>
          </div>
        )}
        <div style={{
          width: "15% !important",
          height: "100% !important",
          display: "flex",
          alignItems: "center",
          paddingBottom: "14px"
        }}>
          {!props.config?.configDetails?.disableTypingIndicatorStatus && (
            <div className="s360-conversation-header-agent-ping-status-container">
              <div className="s360-conversation-header-agent-ping-status"
                style={{ backgroundColor: statusColor }} />
            </div>
          )}
        </div>
        <div style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginLeft: isFullScreen ? "0%" : "2%"
        }}>
          <div className={`s360-conversation-header-details-title${isFullScreen ? "-fs" : ""}`}>
            {parseName()}
          </div>
          {!props.config.configDetails?.disableTypingIndicatorStatus && (
            <div className="s360-conversation-typing-indicator">
              ACTIVE NOW
            </div>
          )}
        </div>
      </div>
      <div className={`s360-conversation-header-container-menu-container${isFullScreen ? "-fs" : ""}`}>
        {/* <LanguageToggle />  */}
        {props.config.languageSwitcher && isShowToggle && <LanguageToggle {...props} />}
        {isAnyMenuActionsEnabled ? (
          <div
            ref={menuContainerRef}
            className="menu-item"
            style={{ paddingRight: canDownloadTranscript && isManualSessionActionEnabled ? "0rem" : "2rem" }}
          >
            {isAnyMenuActionsEnabled  &&
              menuOptionImage(isAnyMenuActionsEnabled)
            }
            {isAnyMenuActionsEnabled && (
              <Menu
                key={"options-menu-" + isMenuOpen}
                anchorEl={menuContainerRef.current}
                open={!!isMenuOpen}
                onClose={menuOptionClose}
              >
                {canDownloadTranscript && (
                  <MenuItem
                    className="s360-conversation-header-options-menu-item"
                    style={customDesign?.conversationHeaderOptionsMenuItem}
                    onClick={onSendChatTranscriptClick}
                  >
                    Send chat transcript
                  </MenuItem>
                )}
                {isManualSessionActionEnabled && isActiveConversation && (
                  <MenuItem
                    className="s360-conversation-header-options-menu-item"
                    style={customDesign?.conversationHeaderOptionsMenuItem}
                    onClick={closeConversationClick}
                  >
                    Restart Conversation
                  </MenuItem>
                )}
                {notificationEnabled && isActiveConversation && (
                  <MenuItem
                    className="s360-conversation-header-options-menu-item"
                    style={customDesign?.conversationHeaderOptionsMenuItem}
                    onClick={()=>{
                      let tempPlaySound = props?.playSound;
                     
                      props.muteNotification(!tempPlaySound)}}
                  >
                    {props.playSound ? 'Mute Notification' : 'Unmute Notification'}
                  </MenuItem>
                )}
              </Menu>
            )}
            {canDownloadTranscript && !isActiveConversation &&
              <div onClick={onSendChatTranscriptClick} style={{ cursor: "pointer" }} />
            }
            {isManualSessionActionEnabled &&
              !canDownloadTranscript &&
              isActiveConversation &&
              (isNullOrUndefined(props.config.forceCloseButton)
                ? true
                : props.config.forceCloseButton) && (
              <div
                style={{ cursor: "pointer" }}
                onClick={closeConversationClick}
              >
                <img height={10} width={10} src={closeIcon} alt=""></img>
              </div>
            )}
          </div>
        ) : null}

        {isFullScreen
          ? showMizimizeOnFullScreen
            ? <div className="s360-conversation-header-icon-container" onClick={onClose} 
              style={{ display: s360ConfigService?.config?.preview ?'none':'flex' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13.624" height="53px"
                viewBox="0 0 13.624 8.209">
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  className="s360-conversation-header-down-icon"
                  style={customDesign?.conversationHeaderDownIcon}
                />
              </svg>
            </div>
            : <div className="s360-conversation-header-icon-container" onClick={closeConversationClick}  style={{ display: s360ConfigService?.config?.preview ?'none':'flex' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13 1L1 13"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 1L13 13"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          : s360ConfigService?.config?.showCloseIcon
            ? <div className="s360-conversation-header-icon-container" onClick={closeConversationClick}  style={{ display: s360ConfigService?.config?.preview ?'none':'flex' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13 1L1 13"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 1L13 13"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            : <div className="s360-conversation-header-icon-container" onClick={onClose}  style={{ display: s360ConfigService?.config?.preview ?'none':'flex' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13.624" height="53px"
                viewBox="0 0 13.624 8.209">
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  className="s360-conversation-header-down-icon"
                  style={customDesign?.conversationHeaderDownIcon}
                />
              </svg>
            </div>
        }
      </div>
    </div>
  );
}

export default ConversationHeader;
